<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'roleList' }">角色管理</router-link>
                </li>
                <li class="active">(添加角色)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules">
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model="saveModel.name"></el-input>
                </el-form-item>
                <el-form-item label="角色级别" prop="level">
                    <el-input type="number" v-model="saveModel.level"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveRole">保存</el-button>
                    <el-button @click="resetForm('formName')">重置</el-button>
                    <el-button @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            roleId: '',
            saveModel: {
                name:'',
                level: '',
            },
            rules: {
                name: [
                    { required: true, message: "请输入角色名称", trigger: "blur" }
                ],
                level: [
                    { required: true, message: "请输入角色等级", trigger: "blur" }
                ]
            },
        }
    },
    created() {
        var _this = this;
        _this.roleId = _this.$route.query.roleId;
        if (_this.roleId) {
            _this.detailRole();
        }
    },
    methods: {
        detailRole() {
            var _this = this;
            _this.$common.my_ajax({
                url: '/role/detailRole',
                data: {
                    roleId: _this.roleId
                },
                success: function(response) {
                    if(response.item){
                      _this.saveModel = response.item || {};
                    }
                }
            });
        },
        saveRole() {
            var _this = this;
            _this.$refs['formName'].validate((valid) => {
                if (valid) {
                    _this.saveModel.code = _this.saveModel.name;
                    _this.$common.my_ajax({
                        url: 'role/saveRole',
                        data: _this.saveModel,
                        success: function(response) {
                            _this.$message({
                                message: '保存成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function() {
                                 _this.$router.push({ name: 'roleList' });
                                }
                            });
                        }
                    });
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
}
</script>